import { INPUT_FIELD_NAMES } from "nlib/common/ContactForm/constants";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Input from "nlib/ui/Input";
import React from "react";
import useContactFormContext from "nlib/common/ContactForm/useContactFormContext";

const ContactFormNameInput = (props) => {
  const { uiTexts } = useSelector(getTextsData);

  const { value, disabled, readOnly, onChange } = useContactFormContext(INPUT_FIELD_NAMES.NAME);

  const hasValue = !!(value && value.trim());

  return (
    <Input
      placeholder={uiTexts.enterContactName}
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      value={value || ""}
      invalid={!hasValue}
      valid={hasValue}
      onChange={onChange} />
  );
};

export default React.memo(ContactFormNameInput);
